import { Link } from 'react-router-dom'
import { GUIDE_NAME, WA_NUMBER, WA_MESSAGES } from '../constants'

export default function Footer() {
  return (
    <footer style={{ background: 'var(--stone)', padding: '60px 5%', borderTop: '1px solid var(--stone-mid)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>
        <div>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
            ktm <span style={{ color: 'var(--green)' }}>travel guide</span>
          </h3>
          <p style={{ fontSize: '14px', color: 'var(--ink-mid)', marginBottom: '20px', maxWidth: '300px' }}>
            Licensed trekking guide based in Kathmandu. Small groups, authentic experiences, and direct bookings with no middlemen.
          </p>
        </div>

        <div>
          <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', fontSize: '14px', lineHeight: '2.2' }}>
            <li><Link to="/">Treks</Link></li>
            <li><Link to="/departures">Departures</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/blog">Trekking Blog</Link></li>
          </ul>
        </div>

        <div>
          <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>Popular Treks</h4>
          <ul style={{ listStyle: 'none', fontSize: '14px', lineHeight: '2.2' }}>
            <li><Link to="/manaslu-circuit">Manaslu Circuit</Link></li>
            <li><Link to="/everest-base-camp">Everest Base Camp</Link></li>
            <li><Link to="/annapurna-circuit">Annapurna Circuit</Link></li>
            <li><Link to="/annapurna-base-camp">Annapurna Base Camp</Link></li>
            <li><Link to="/langtang-valley">Langtang Valley</Link></li>
            <li><Link to="/langtang-gosaikunda">Langtang Gosaikunda</Link></li>
          </ul>
        </div>

        <div>
          <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '20px', textTransform: 'uppercase', letterSpacing: '1px' }}>Contact</h4>
          <p style={{ fontSize: '14px', color: 'var(--ink-mid)', marginBottom: '16px' }}>
            Ready to plan your trek? WhatsApp me directly for questions or bookings.
          </p>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
            target="_blank" rel="noreferrer"
            className="btn btn-green btn-sm"
          >
            Message {GUIDE_NAME}
          </a>
        </div>
      </div>

      <div style={{ marginTop: '60px', paddingTop: '24px', borderTop: '1px solid var(--stone-mid)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', fontSize: '12px', color: 'var(--ink-light)' }}>
        <div>© {new Date().getFullYear()} KTM Travel Guide. All rights reserved.</div>
        <div style={{ display: 'flex', gap: '20px' }}>
          <span>Terms</span>
          <Link to="/privacy" style={{ color: 'var(--ink-light)' }}>Privacy</Link>
        </div>
      </div>
    </footer>
  )
}
